import React from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './PointsSection.style'

const PointsSection = ({ altMode }) => {
  const classes = useStyles()
  const { championship } = useSelector((state) => state.championships)
  const { championshipPoints, minLapPercentageRequired, fixtures } = championship

  const chunkArray = (array, chunkSize, blocksCount = null) => {
    const chunks = array.reduce((acc, item, index) => {
      const chunkIndex = Math.floor(index / chunkSize)
      if (!acc[chunkIndex]) acc[chunkIndex] = []

      acc[chunkIndex].push(item)
      return acc
    }, [])

    const totalBlocks =
      blocksCount !== null && chunks.length > 0
        ? Math.ceil(chunks.length / blocksCount) * blocksCount
        : chunks.length

    const filledChunks = Array.from({ length: totalBlocks }, (_, idx) => chunks[idx] || [])

    return filledChunks.map((chunk) =>
      chunk.length < chunkSize
        ? chunk.concat(new Array(chunkSize - chunk.length).fill(null))
        : chunk
    )
  }

  const hasGeneralPoints = championshipPoints.some((x) => x.position !== 0)

  const result = hasGeneralPoints
    ? chunkArray(
        championshipPoints.filter((x) => x.position !== 0).sort((x, y) => x.position - y.position),
        10,
        2
      )
    : []

  const fixturePositionPoints = !hasGeneralPoints
    ? fixtures
        .filter((fixture) => fixture.points.some((point) => point.position !== 0))
        .map((fixture) => ({
          dateNumber: fixture.dateNumber,
          points: fixture.points
            .filter((point) => point.position !== 0)
            .sort((a, b) => a.position - b.position)
        }))
        .sort((a, b) => a.dateNumber - b.dateNumber)
    : []

  const fixtureResult = fixturePositionPoints.map((fixture) => ({
    dateNumber: fixture.dateNumber,
    blocks: chunkArray(fixture.points, 10, 2)
  }))

  const fixturesAssistancePoints = fixtures
    .flatMap((fixture) => {
      const point = fixture.points.find((p) => p.position === 0)

      return point
        ? [
            {
              dateNumber: fixture.dateNumber,
              points: point.points
            }
          ]
        : []
    })
    .sort((a, b) => a.dateNumber - b.dateNumber)

  const hasFixturePositionPoints = !!fixturePositionPoints.length
  const hasFixtureAssistencePoints = !!fixturesAssistancePoints.length
  const assistancePoint = !hasFixtureAssistencePoints
    ? championshipPoints.find((x) => x.position === 0)
    : null

  return (
    <SectionBlock
      title='Puntaje'
      titleClassName={!hasGeneralPoints && !fixturePositionPoints.length && classes.title}
      className={clsx(altMode && classes.altSection)}>
      <div className={classes.container}>
        {!hasGeneralPoints && !fixturePositionPoints.length && (
          <Typography variant='h6' className={classes.emptyMessage}>
            No hay puntos cargados
          </Typography>
        )}

        {!hasFixturePositionPoints && !!result.length && (
          <div className={classes.pointContent}>
            <div className={classes.content}>
              {result.map((points, index) => (
                <table className={classes.table} key={index}>
                  <thead className={classes.headerRow}>
                    <tr>
                      <th>Puesto</th>
                      <th>Puntos</th>
                    </tr>
                  </thead>
                  <tbody>
                    {points.map((point, i) => (
                      <tr key={i}>
                        <td align='center'>{point ? point.position : index * 10 + i + 1}°</td>
                        <td align='center'>{point ? `${point.points}` : '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ))}
            </div>
          </div>
        )}

        {hasFixturePositionPoints &&
          fixtureResult.map((fixture) => (
            <div key={fixture.dateNumber} className={classes.pointContent}>
              <Typography variant='h6' color='primary' className={classes.assistancePoint}>
                Fecha {fixture.dateNumber}
              </Typography>
              <div className={classes.content}>
                {fixture.blocks.map((block, index) => (
                  <table className={classes.table} key={`${fixture.dateNumber}-${block}-${index}`}>
                    <thead className={classes.headerRow}>
                      <tr>
                        <th>Puesto</th>
                        <th>Puntos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {block.map((point, i) => (
                        <tr key={i}>
                          <td align='center'>{point ? point.position : index * 10 + i + 1}°</td>
                          <td align='center'>{point ? point.points : '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ))}
              </div>
            </div>
          ))}

        {!!assistancePoint && (
          <Typography variant='h6' color='primary' className={classes.assistancePoint}>
            Presentimo:&nbsp;
            <Typography variant='caption'>{assistancePoint.points} Punto/s </Typography>
          </Typography>
        )}
        {hasFixtureAssistencePoints &&
          fixturesAssistancePoints.map((fixture) => (
            <Typography
              key={fixture.dateNumber}
              variant='h6'
              color='primary'
              className={classes.assistancePoint}>
              Presentismo Fecha {fixture.dateNumber}:&nbsp;
              <Typography variant='caption'>{fixture.points} Punto/s </Typography>
            </Typography>
          ))}

        {!!minLapPercentageRequired && (
          <Typography variant='h6' color='primary' className={classes.assistancePoint}>
            % mínimo de vueltas para puntuar:&nbsp;
            <Typography variant='caption'>{minLapPercentageRequired}</Typography>
          </Typography>
        )}
      </div>
    </SectionBlock>
  )
}

export default PointsSection
